import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CulturalEvent } from '../constants/culturalEventsTypes';
import './CulturalEventCard.css';

interface CulturalEventCardProps {
  event: CulturalEvent;
}

export const CulturalEventCard: React.FC<CulturalEventCardProps> = ({ event }) => {
  const navigate = useNavigate();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleDateString('en-GB', { month: 'short' });
    return { day, month };
  };

  const formatTime = (timeString: string) => {
    return timeString.substring(0, 5); // "11:00:00" -> "11:00"
  };

  const { day, month } = formatDate(event.date);

  const handleViewDetails = () => {
    navigate(`/cultural-events/${event._id}`);
  };

  return (
    <div className="cultural-event-card" onClick={handleViewDetails}>
      <div className="cultural-event-card__header">
        <div className="cultural-event-card__date-badge">
          <div className="date-badge__day">{day}</div>
          <div className="date-badge__month">{month}</div>
        </div>
        <div className="cultural-event-card__type-badge">
          {event.eventType}
        </div>
      </div>

      <div className="cultural-event-card__body">
        <h3 className="cultural-event-card__title">{event.title}</h3>
        <p className="cultural-event-card__description">
          {event.description.length > 120
            ? `${event.description.substring(0, 120)}...`
            : event.description}
        </p>

        <div className="cultural-event-card__meta">
          <div className="meta__item">
            <span className="meta__icon">📍</span>
            <span className="meta__text">{event.location}</span>
          </div>
          <div className="meta__item">
            <span className="meta__icon">🕐</span>
            <span className="meta__text">{formatTime(event.time)}</span>
          </div>
        </div>
      </div>

      <div className="cultural-event-card__footer">
        <div className="cultural-event-card__price">
          {event.isFree ? (
            <span className="price__free">Free</span>
          ) : (
            <span className="price__amount">£{event.price}</span>
          )}
        </div>
        <button 
          className="cultural-event-card__btn"
          onClick={(e) => {
            e.stopPropagation();
            handleViewDetails();
          }}
        >
          View Details
        </button>
      </div>
    </div>
  );
};
